<div class="landing-page">
  <h1 class="title">Registr zastupování</h1>
  <p>
    Informační systém oprávnění k zastupování provozovaný Digitální a informační agenturou dle § 52a zákona č. 111/2009
    Sb. o Základních registrech, slouží k zápisu a vedení údajů o oprávnění k zastupování, údajů o typech oprávnění k
    zastupování a údajů o certifikátech pro uznávané elektronické podpisy a uznávané elektronické pečetě v rozsahu údajů
    pro ověřování těchto podpisů a pečetí.
  </p>

  <reza-warning-text-field></reza-warning-text-field>

  <div class="link-element" data-cy="link-seznam-sablon">
    <a routerLink="/seznam-sablon" routerLinkActive="active" ariaCurrentWhenActive="page"
      ><i class="pi pi-info-circle"></i>Katalog typu oprávnění k zastupování<i class="pi pi-angle-right"></i
    ></a>
    <p>Oprávnění k zastupování jsou sestavována podle schválených typů oprávnění k zastupování (šablon).</p>
  </div>

  <div class="link-element" data-cy="link-seznam-skupin-sablon">
    <a routerLink="/katalog-skupin-sablon" routerLinkActive="active" ariaCurrentWhenActive="page"
      ><i class="pi pi-info-circle"></i>Katalog skupin typu oprávnění k zastupování<i class="pi pi-angle-right"></i
    ></a>
    <p>
      Skupiny typů oprávnění k zastupování (šablon) obsahují typy oprávnění k zastupování (šablony) dle kterých je možné
      sestavit oprávnění k zastupování pro pověřenou osobu.
    </p>
  </div>

  <div class="link-element" data-cy="link-prirucka">
    <a routerLink="/dms" routerLinkActive="active" ariaCurrentWhenActive="page"
      ><i class="pi pi-receipt"></i>Dokumentace<i class="pi pi-angle-right"></i
    ></a>
    <p>Dokumentace k AIS REZA a uživatelská příručka.</p>
  </div>
</div>
